"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function NewsList() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="flex flex-col border-t border-border">
        {[...Array(5)].map((_, i) => <div key={i} data-index={i} className="flex flex-col md:flex-row gap-6 py-8 border-b border-border animate-pulse">
            <div className="shrink-0 w-full md:w-64 aspect-[3/2] rounded-md bg-muted" />
            <div className="flex flex-col justify-center flex-1 space-y-4">
              <div className="h-5 w-24 bg-muted rounded-lg" />
              <div className="h-8 w-3/4 bg-muted rounded-md" />
              <div className="h-4 w-full bg-muted rounded-md" />
              <div className="h-4 w-2/3 bg-muted rounded-md" />
            </div>
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="py-12 text-center text-muted-foreground">
        <p>Unable to load news, please try again later.</p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="py-12 text-center text-muted-foreground">
        <p>No news available.</p>
      </div>;
  }
  return <div className="flex flex-col border-t border-border">
      {posts.map((post, i) => <article key={post.id} data-index={i} className="group flex flex-col md:flex-row gap-6 md:gap-10 py-8 border-b border-border last:border-0">
          <div className="shrink-0 w-full md:w-72 aspect-[3/2] overflow-hidden rounded-md bg-muted">
            {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" loading="lazy" /> : <div className="w-full h-full bg-secondary flex items-center justify-center">
                <span className="text-muted-foreground text-sm">STI Group</span>
              </div>}
          </div>
          
          <div className="flex flex-col justify-center flex-1">
            <div className="mb-4">
              <Badge variant="outline" className="rounded-lg border-primary/30 text-primary bg-primary/5">
                {post.date ? new Date(post.date).toLocaleDateString('zh-CN') : 'Latest'}
              </Badge>
            </div>
            
            <Link to={post.link || "#"} className="block mb-3">
              <h3 className="text-2xl md:text-3xl font-default font-semibold text-foreground transition-colors duration-300 group-hover:text-primary line-clamp-2">
                {post.title}
              </h3>
            </Link>
            
            <p className="text-muted-foreground text-base md:text-lg line-clamp-2 mb-6">
              {post.excerpt?.replace(/<[^>]*>?/gm, '') || "Read more for detailed content and in‑depth analysis."}
            </p>
            
            <div className="mt-auto">
              <Link to={post.link || "#"} className="inline-flex items-center text-sm font-medium text-foreground transition-colors duration-300 group-hover:text-primary">
                Read More <ArrowRight className="ml-2 size-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
            </div>
          </div>
        </article>)}
    </div>;
}
export default function News() {
  const wp_query_params = {
    post_type: "post",
    per_page: 5,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="news-insights" className="bg-background py-20 md:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="mb-12 md:mb-16 flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div className="max-w-2xl">
            <h2 className="text-4xl md:text-5xl font-default font-bold tracking-tight text-foreground mb-4">
              News & Insights
            </h2>
            <p className="text-lg text-muted-foreground">
              Latest updates, industry insights, and global investment perspectives from STI Group.
            </p>
          </div>
          <Link to="/NewsPage" className="inline-flex items-center text-sm font-medium text-primary hover:text-primary/80 transition-colors">
            View All News <ArrowRight className="ml-2 size-4" />
          </Link>
        </div>
        
        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 5,
        orderby: "date",
        order: "desc"
      }}>
          <NewsList />
        </PostsProvider>
      </div>
    </section>;
}